import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSearchFilters } from '../../../../../reduxToolkit/Search/SearchSlice';
import { RemoveCardToUser } from '../../../../../reduxToolkit/Cards/CardsApi';
import {GetEmployeeDetailsByUserId} from "../../../../../reduxToolkit/Employee/EmployeeApi";
import {useParams} from "react-router-dom";

const Step7CardApp = ({ cardsList, setCardsList, setCardData, setCardDataInfo, componentAction, userData }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deletedFlag, setDeletedFlag] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [finalArray, setFinalArray] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [deleteCardShow, setDeleteCardShow] = useState(false);
    const [selectCardForDelete, setSelectCardForDelete] = useState([]);
    const [assignFreeCardShow, setAssignFreeCardShow] = useState(false);
    const [excludedId, setExcludedId] = useState([]);
    const [previewShow, setPreviewShow] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    // useSelector
    const { getPreview } = useSelector((state) => state.CardsSlice);

    // useEffect to avoid first load
    useEffect(() => {
        setLoaded(true);
        return () => {
            dispatch(clearSearchFilters());
        };
    }, []);

    useEffect(() => {
        const selectAllIds = cardsList?.map((item) => {
            return { id: item?.id };
        });
        setCardData(selectAllIds);
        setCardDataInfo(cardsList);
    }, [cardsList]);

    //Create body for the respectively search
    useEffect(() => {
        if (loaded) {
            setLoaded(false);
            setDeletedFlag(false);
        }
    }, [loaded, page, rowsPerPage, finalArray, deletedFlag]);

    const unassignCard = () => {
        if (componentAction === 'update') {
            const body = {
                cardIds: selectCardForDelete,
                userId: userData.id,
            };
            dispatch(RemoveCardToUser(body)).then(
                ({
                    payload: {
                        data: { success },
                    },
                }) => {
                    if (success === true) {
                        dispatch(GetEmployeeDetailsByUserId(id)).then(
                            ({
                                 payload: {
                                     data: { data },
                                 },
                             }) => {
                                setCardsList(data?.cards);
                                reset();
                            },
                        );
                    }
                },
            );
        } else {
            const filteredCards = cardsList.filter((card) => !selectCardForDelete.includes(card.id));
            setCardsList(filteredCards);
            reset();
        }
    };

    const reset = () => {
        setSelectCardForDelete([]);
        setIsAllChecked(false);
    }

    const handleOnHidePreviewModal = () => {
        setPreviewShow(false);
        dispatch(getPreview());
    }

    const handleItem = (item) => {
        if (item.templateId !== null) {
            setCurrentId(item?.id);
            setPreviewShow(true);
        }
    }

    return {
        selectCardForDelete,
        setSelectCardForDelete,
        excludedId,
        currentId, setCurrentId,
        previewShow, setPreviewShow,
        isAllChecked,
        setIsAllChecked,
        deleteCardShow, setDeleteCardShow,
        setAssignFreeCardShow, assignFreeCardShow,
        unassignCard: () => unassignCard(),
        handleOnHidePreviewModal: (e) => handleOnHidePreviewModal(e),
        handleItem : (e) => handleItem(e)
    }

}

export default Step7CardApp;
